export enum EnumEstadoAuditoria {
  EnConstruccion = 1,
  AuditoriaAprobada = 2,
  PlanListo = 3,
  InformeListo = 4,
  InformeRechazado = 5,
  InformeCompletado = 6,
  InformeCerrado = 7,
  AuditoriaCerrada = 8,
}
